import React from 'react';
import AlertPage from './components/AlertPage';

const AlertView = props => {
  const { alertId } = props.match.params;
  return <AlertPage alertId={alertId} />;
};

export { AlertView };
